"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var animation_context_1 = require("./animation-context");

var AnimationGroup = function AnimationGroup(props) {
  var stagger = 0;
  return react_1.default.createElement(animation_context_1.AnimationContext.Provider, {
    value: {
      started: props.started,
      getStagger: function getStagger() {
        return stagger;
      },
      increaseStagger: function increaseStagger() {
        return stagger = stagger + (props.stagger || 0);
      }
    }
  }, props.children);
};

exports.default = AnimationGroup;